module.exports = __webpack_public_path__ + "static/product-l0980-red-186696f39c075b5b293407752ccb7f87.png";